import React from 'react';
import { Container, Row,Col, Card, Alert, Button, Modal } from "react-bootstrap";
import Input from '../components/Input';
import axios from '../axiosInterceptor';
import { useNavigate } from 'react-router-dom';

function ResetPassword() {

  const navigate = useNavigate();
  const [email,set_email] = React.useState("");
  const [valid,set_valid] = React.useState(false);
  const [show, set_show] = React.useState(false);
  const [error, set_error] = React.useState({ hide:true, message:"" });


  const on_change = (e,valid) => {
    
    set_email(()=> e.target.value);
    set_valid(()=> valid);

  }

  const on_submit = () => {
    if(valid){
      
      axios.get(`/auth/resetPassword/${email}`).then(()=>{
        set_show(()=> true);

      }).catch((error)=>{

        if(error.status >= 500){
          set_error(()=> ({hide:false,message:error.message}));
        }
        else{
          set_error(()=> ({hide:false,message:error.validations[0].message}));
        }
      });
    }
  }

  const hide_modal = () => {
    set_show(()=> false);
    navigate('/login');
  }

  return (
   <Container className='mt-4'>
      <Row className='justify-content-center'>
        <Col xs='10' sm='8' md='8' lg='5' xl='4'>
          <Card>
            <Card.Body>
              <Card.Title className='text-center mb-4'>Restablecer Contraseña</Card.Title>

              <Alert key={'primary'} variant={'primary'}>
                Introduce tu correo electrónico y te enviaremos un enlace para restablecer tu contraseña.
              </Alert>
             
              <Input 
                label='Correo Electrónico' 
                name='email'
                type='email' 
                placeholder='Correo Electrónico'
                required={true}
                onChange={on_change}
              />

              <Alert className='mt-4' hidden={error.hide} key={'danger'} variant={'danger'}>
                {error.message}
              </Alert>

              <Button onClick={on_submit} variant="primary" className='mt-3' style={{display:"table",marginLeft:"auto",marginRight:"auto"}}>Resetear Contraseña</Button>

            </Card.Body>
          </Card>
        </Col>
        
      </Row>
        
      <Modal show={show} onHide={hide_modal}>
        <Modal.Header closeButton>

          <Modal.Title>Exito</Modal.Title>

        </Modal.Header>

        <Modal.Body>Se ha enviado un correo a tu dirección de correo electrónico para restablecer tu contraseña.</Modal.Body>
        <Modal.Footer>

          <Button variant="secondary"  onClick={hide_modal}> Aceptar </Button>

        </Modal.Footer>
      </Modal>
   </Container>
  )
}



export default ResetPassword